import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const callOrderCodeGetApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.get(API.orderCode, {
    params: {
      customerId: payload.customerId,
      orderNumber: payload.id,
      denomination: payload?.deno,
    },
  });
  return data;
};
